import { useEffect } from 'react'
import { useQueryParams } from '@fs/zion-router'
import { useR2DispatchContext, useR2StateContext } from '../../../providers/r2Provider/R2Context'
import { useOverlayContext } from '../../../../shared/providers/overlayContextProvider/OverlayContext'

export default function useR2PanelCloser() {
  const r2State = useR2StateContext()
  const r2Dispatch = useR2DispatchContext()
  const { query } = useQueryParams()
  const overlayContext = useOverlayContext()

  // Just let the resetState go through to remove all panels from memory so we don't have to
  // worry about the side effects from closing all of the overlays.
  // Overlays watch the close event and do things.  This is a temporary solution to our handle navigate mess
  useEffect(() => {
    if (r2State.resetState) {
      if (query.view !== 'explore') overlayContext.switchImageCheck()
      if (r2State.resetState) r2Dispatch({ type: 'SET_STATE', value: { resetState: false } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [r2Dispatch, overlayContext, query.mode])
}
